import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6972aeac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-item-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "grid-item-head-title" }, "観測局一覧")
], -1))
const _hoisted_2 = { class: "grid-item-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "局名", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "no" }
const _hoisted_6 = { class: "station-name" }

import { computed } from 'vue'
import { camelCase } from 'lodash'
import { FieldListItem } from '@/models/InitData'
import { DefinitionInfoSummaryItemList } from '@/models/initData/DefinitionInfo'
import { useRouter } from 'vue-router'
import { useInitDataStore } from '@/stores/initDataStore'
import { usePresentStore } from '@/stores/presentStore'

type StationListPanelPropType = {
  cell: DefinitionInfoSummaryItemList
}

export default /*#__PURE__*/_defineComponent({
  props: {
    cell: null
  },
  setup(__props: any) {

const props = __props as {
  cell: DefinitionInfoSummaryItemList
}



const router = useRouter()
const initDataStore = useInitDataStore()
const presentStore = usePresentStore()
const stations = computed(() => {
  const targets = props.cell.args.stationList.map(station => {
    const target = initDataStore.initData.stationList.find(s => s.stationId === station.stationId)
    const values = {} as {
      [key: string]: {
        color: string
        value: number
        fieldInfo: FieldListItem
      }
    }

    props.cell.args.fieldList.forEach(field => {
      const fieldId = field.fieldId
      const fieldInfo = initDataStore.initData.fieldList[camelCase(fieldId)]
      const value = presentStore.getValue(station.stationId, fieldId) as number
      const alert = presentStore.getAlertLevel(station.stationId, fieldId)
      const threshold = props.cell.args.thresholdInfo[camelCase(fieldId)]
      let color = ''

      threshold.forEach(th => {
        if ((th.comparison && th.comparison <= value) || th.status === alert) {
          color = th.color
        }
      })

      values[fieldId] = { color, value, fieldInfo }
    })

    return { ...target, ...station, values }
  })

  return targets.filter(t => t)
})
const handleClickStation = (station: { stationId: string }) => {
  const path = `/rain_detail/${station.stationId}`

  router.push(path)
}
const renderValue = (value?: number, decimal?: number) => {
  if (value === undefined || value === null) {
    return '-'
  }

  return value.toFixed(decimal)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cell.args.fieldList, (field) => {
            return (_openBlock(), _createElementBlock("th", {
              key: field.fieldId
            }, _toDisplayString(field.title), 1))
          }), 128))
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stations), (station) => {
            return (_openBlock(), _createElementBlock("tr", {
              onClick: ($event: any) => (handleClickStation(station)),
              key: station.stationId
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(station.no), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(station.name), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(station.values, (value, key) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: key,
                  style: _normalizeStyle(`color: ${value.color}`),
                  class: "field"
                }, _toDisplayString(renderValue(value.value, value.fieldInfo.decimal)), 5))
              }), 128))
            ], 8, _hoisted_4))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})